import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  erro: boolean;
  tentativa: number;
}

// Isola o erro de uma aba para que ela não derrube o painel inteiro.
export default class ErroAba extends Component<Props, State> {
  state: State = { erro: false, tentativa: 0 };

  static getDerivedStateFromError(): Partial<State> {
    return { erro: true };
  }

  componentDidCatch(): void {
    // O erro é exibido pela UI; nada a fazer aqui.
  }

  render() {
    if (this.state.erro) {
      return (
        <div className="rounded-lg border border-secondary-200 bg-white p-10 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
            <i className="ri-error-warning-line text-2xl" />
          </span>
          <p className="mt-4 text-[15px] text-foreground-800">Esta aba deu um erro. Tente de novo.</p>
          <button
            type="button"
            onClick={() => this.setState({ erro: false, tentativa: this.state.tentativa + 1 })}
            className="mt-4 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            Recarregar
          </button>
        </div>
      );
    }
    return <div key={this.state.tentativa} className="contents">{this.props.children}</div>;
  }
}